<template>
  <div class="modal fade bd-example-modal-lg" :id="dataTarget" tabindex="-1" role="dialog"
       :aria-labelledby=selector
       aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title font-weight-600" :id=selector>訂購明細</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body p-0">
          <div class="mt-3"/>
          <div class="row m-0 px-3">
            <img class="col-lg-2 col-md-6 col-sm-12 p-0 rounded-3 position-relative" :src="img">
            <TagItem :text="'預訂'" :color="'red'" class="position-absolute" style="top: 25px; left: 25px"></TagItem>
            <div class="col-lg-10 col-md-6 col-sm-12 px-md-3 px-0">
              <span
                  class="text-custom-text font-weight-500 h4 font-weight-600">{{ title }}</span>
              <div class="mt-1"/>
              <div class="d-flex grid-gap">
                <div v-for="(item, index) in tag_list" :key="index">
                  <TagItem :text="item.text" :color="item.color"/>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-1"></div>

          <div v-if="note" class="row m-0 px-3">
            <TagItem :text="'備註'" :color="'white'"></TagItem>
            <div class="ml-1"></div>
            <div class="text-main-color font-size-16">{{ note }}</div>
          </div>

          <hr class="my-3">

          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">總下單數量</div>
            <div class="col-6 text-right text-custom-text">{{ stock }} PCS</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">湊箱數量</div>
            <div class="col-6 text-right text-custom-text ">{{ combine_buy_amount }} PCS</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">減量</div>
            <div class="col-6 text-right text-orange">-{{ decrease }} PCS</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">實際到貨數量</div>
            <div class="col-6 text-right text-custom-text">{{ actual_stock }} PCS</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">總價</div>
            <div class="col-6 text-right text-custom-text">JPY ¥{{ total_price }}</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">匯率折扣</div>
            <div class="col-6 text-right text-orange">JPY -¥25,999</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600 ">湊箱折扣</div>
            <div class="col-6 text-right text-orange">JPY -¥24,000</div>
          </div>
          <div class="mt-1"></div>
          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">即時匯率</div>
            <div class="col-6 text-right text-custom-text">{{ exchange_rate }} PCS</div>
          </div>

          <hr class="my-3">

          <div class="row m-0 ">
            <div class="col-6">
              <div class="h5 m-0 text-custom-text font-weight-600">
                預估到貨價
              </div>

              <div class="text-custom-description">
                (預估到貨價 = 日幣 x 折扣 x 發貨日匯率)
              </div>

            </div>
            <div class="col-6 text-right text-custom-text-2 ">
              <div class="h6 m-0 font-weight-600">約TWD</div>
              <div class="h3 m-0 font-weight-600">
                50999<span class="h6 m-0 pl-1 font-weight-600 ">元</span>
              </div>
            </div>
          </div>

          <hr class="my-3">

          <div class="row m-0 ">
            <div class="col-12 h5 text-custom-text font-weight-600">更新記錄</div>
          </div>

          <div class="d-grid grid-gap">
                        <div v-for="(item, index) in history_list" :key="index" class="mx-5">
                          <HistoryItem
                              :title="item.title"
                              :create_data="item.create_data"
                              :before_text="item.before_text"
                              :after_text="item.after_text"
                          />
                        </div>
          </div>

          <hr class="my-3">

          <div>
            <base-pagination :page-count="pageCount" align="center" v-model="page"></base-pagination>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import TagItem from "@/views/components/elements/TagItem";
import HistoryItem from "@/views/components/elements/HistoryItem";
import {generateUuidNo} from "@/util/helpers";

export default {
  name: "OrderDialogItem",
  components: {
    TagItem: TagItem,
    HistoryItem: HistoryItem,
  },
  props: {
    dataTarget:{
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: "",
    },
    tag_list: {
      type: Array,
      default: () => [],
    },
    total_price: {
      type: Number,
      default: 0,
      text: "總價",
    },
    discount: {
      type: Number,
      default: 0,
    },
    combine_buy_discount: {
      type: Number,
      default: 0,
    },
    stock: {
      type: Number,
      default: 0,
      text: "總下單數量",
    },
    combine_buy_amount: {
      type: Number,
      default: 0,
      text: "湊箱數量"
    },
    exchange_rate: {
      type: Number,
      default: 0,
      text: "即時匯率"
    },
    decrease: {
      type: Number,
      default: 0,
      text: "減量"
    },
    actual_stock: {
      type: Number,
      default: 0,
      text: "實際到貨數量"
    },
    history_list:{
      type: Array,
      default: () => [],
      // default : [],
    },
    page: {
      type: Number,
      default: 1,
    },
    pageCount: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      selector: '',
    };
  },
  created() {
    const randomNum = generateUuidNo();
    this.selector = `order_dialog_item_${randomNum}`;
  },
  methods: {
    calculatePrice() {
      //TODO 計算價格
    }
  }

}
</script>

<style scoped>

.grid-gap {
  grid-gap: 10px;
}

</style>
